<template lang="pug">
  b-modal#deleteProvider(
  ref="deleteProvider"
  :title="$t('ui.combine.delete_provider')"
  centered
  no-fade
  no-close-on-backdrop
  ok-variant="danger"
  :busy="loading"
  @ok="done"
  @show="reset").dialog-box
    div(novalidate)
      div.row.mt-3
        div.col.text-center
          span.h5.text-danger {{ $t('message.delete_confirm', { name: providerName }) }}
      div.row.mb-3
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-trash" :text="$t('ui.delete')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    providerId: "",
    providerName: ""
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {},
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      let url = config.deleteProviderUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.provider,
        target_provider_id: this.providerId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked", this.providerId);
                this.$refs.deleteProvider.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "delete_provider", this.feedback.status);
                this.$refs.deleteProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    }
  }
};
</script>